// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import App from '@/app'
import VueCookie from 'vue-cookie'
import '@/assets/scss/sb-admin-2.scss'
import 'jquery'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import { directive as onClickaway } from 'vue-clickaway'
Vue.directive('on-clickaway', onClickaway)
Vue.use(Loading)
Vue.use(VueCookie)
Vue.config.productionTip = false
axios.defaults.baseURL = 'https://api.linksider.online/'
// axios.defaults.baseURL = 'http://localhost:8081'
Vue.prototype.$http = axios
/* eslint-disable no-new */
new Vue({
  el: '#app',
  data () {
    return {
      loader: null
    }
  },
  router,
  created () {
    axios.interceptors.request.use(config => {
      if (this.loader !== null && this.loader !== undefined) this.loader.hide()
      this.loader = Vue.$loading.show({
        loader: 'dots',
        opacity: 0.8,
        backgroundColor: 'transparent',
        color: '#54BB65',
        isFullPage: true
      })
      return config
    })
    axios.interceptors.response.use(response => {
      if (this.loader !== null && this.loader !== undefined) this.loader.hide()
      return response
    }, err => {
      if (this.loader !== null && this.loader !== undefined) this.loader.hide()
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
        }
        throw err
      })
    })
  },
  render: h => h(App)
})
router.beforeEach((to, from, next) => {
  if (this.loader !== null && this.loader !== undefined && to.name) {
    this.loader = Vue.$loading.show({
      loader: 'dots',
      opacity: 0.8,
      backgroundColor: 'transparent',
      color: '#54BB65',
      isFullPage: true
    })
  }
  next()
})

router.afterEach((to, from) => {
  if (this.loader !== null && this.loader !== undefined) this.loader.hide()
})



// WEBPACK FOOTER //
// ./src/main.js